import axios from "axios";
import Cookies from "js-cookie";
import { getFirm } from "../getFirm";
import { FIRMFLOWURL } from "../url";

export const previewPipelineChange = ({ firmId, serviceId, newJobId }) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            let resolvedFirmId = firmId;

            if (!resolvedFirmId) {
                const firm = await getFirm();
                if (!firm.success) {
                    resolve({
                        success: false,
                        data: null,
                        message: firm.message || "Unable to resolve firm id.",
                    });
                    return;
                }
                resolvedFirmId = firm.data.id;
            }

            const response = await axios.get(
                `${FIRMFLOWURL}api/Service/firm/${resolvedFirmId}/service/${serviceId}/pipeline-change/preview`,
                {
                    params: { newJobId },
                    headers: { Authorization: token },
                },
            );

            resolve({
                ...response,
                success: response.data?.success ?? true,
                data: response.data,
                message: response.data?.message,
            });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, data: null, message: err.message });
        }
    });
};
